export default [
  { title: "Get envelope tab values", icon: "", link: "/docs/get-envelope-tabs" },
  { title: "Get envelope custom tab values", icon: "", link: "/docs/get-envelope-custom" },
  { title: "Set envelope tab values", icon: "", link: "set-envelope-tabs" },
  { title: "Set tab values in a template", icon: "", link: "/docs/set-tabs-value" },
];
